import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import { useState } from "react";

export const useUploadFiles = () => {
	const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
	const [isDragging, setIsDragging] = useState(false);
	const {
		actions: { setUploadFileDialog },
	} = useTemplatesContext();

	const handleCancel = () => {
		setUploadFileDialog(false);
	};

	const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
		const files = event.target.files ? Array.from(event.target.files) : [];

		if (files.length) {
			const newFiles = [...selectedFiles];
			Array.from(files).forEach((file: File) => {
				if (
					!selectedFiles.some((selectedFile) => selectedFile.name === file.name)
				) {
					newFiles.push(file);
				}
			});
			setSelectedFiles(newFiles);
		}
	};

	const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
		event.preventDefault();
		setIsDragging(true);
	};

	const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
		event.preventDefault();
		setIsDragging(false);

		const files = event.dataTransfer.files;
		if (files.length >= 1) {
			const newFiles = [...selectedFiles];
			Array.from(files).forEach((file: File) => {
				if (
					!selectedFiles.some((selectedFile) => selectedFile.name === file.name)
				) {
					newFiles.push(file);
				}
			});
			setSelectedFiles(newFiles);
		}
	};

	return {
		handleFileSelect,
		handleDragOver,
		handleDrop,
		handleCancel,
		setIsDragging,
		setSelectedFiles,
		selectedFiles,
		isDragging,
	};
};
